import { useMemo } from "react"
import { GetApp } from "../../App"
import { TripContext } from "../../App/Context"
import { useRefCallbacks } from "../../App/useRefCallbacks"
import type { TabBarCallbacks } from "../../Components/TabBar"
import { TripViewData } from "./Context"
import { useTripData } from "./DataContext"
import { TripDaysView } from "./DaysView"
import { TripDetailsView } from "./DetailsView"
import { TripHeaderView } from "./HeaderView"
import type { TripDataProps } from "./Params"

export function TripViewUI({ focus, initTab, overrideDays, tripChildren }: TripDataProps) {
  const app = GetApp();
  const { trip, days, tracks, details, setDetails } = useTripData();
  const tabBarRef = useRefCallbacks<TabBarCallbacks>();
  const state = useMemo(
    () => ({ trip, days: days || overrideDays || [] }),
    [trip, days, overrideDays],
  );
  const { startLocation, endLocation } = TripViewData.tripLocations(trip);
  const daysWithBlanks = useMemo(() => TripViewData.fillDayGaps(days, trip), [days, trip]);

  return (
    <TripContext.Provider value={state}>
      <div
        className={"TripView"
          + (days && days.length == 0 ? " no-days" : "")
          + (app.current?.tripId && trip.id == app.current.tripId ? " active" : "")
          + (focus ? " focus" : "")}
        data-trip-id={trip.id}
      >
        <TripHeaderView
          trip={trip}
          details={details}
          onDetailsChange={setDetails}
          startLocation={startLocation}
          endLocation={endLocation}
        />
        {details && (
          <TripDetailsView
            trip={trip}
            initTab={initTab}
            tabBarRef={tabBarRef}
            tracks={tracks}
          />
        )}
        <TripDaysView daysWithBlanks={daysWithBlanks}>{tripChildren}</TripDaysView>
      </div>
    </TripContext.Provider>
  );
}
